import React from 'react'
import { ContentHeader } from '../../../../../layout/Content'

function ProductsInventoryHeader() {
  return ( <ContentHeader title='Products Inventory' /> )
}

export default React.memo(ProductsInventoryHeader)
